import { useDrawer } from "../../../hooks";
import { AuthContext } from "../../../context";
import { useContext, useState } from "react";
import { Drawer, SimpleToolbar, Loader, Toast } from "../../../components";
import {
  Grid,
  Container,
  makeStyles,
  Paper,
  Box,
  Button,
  Typography,
  Switch,
} from "@material-ui/core";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { FormRepresentative } from "../../../components/form-representative";
import { laboratoryServices } from "../../../services";
import FileUploader from "../../../components/file-uploader";
import { CloudDownloadRounded } from "@material-ui/icons";

export default function CreateRepresentativeScreen() {
  const { authState } = useContext(AuthContext);
  const { isOpen, setIsOpen } = useDrawer();
  const [loading, setLoading] = useState(false);
  const [toast, setToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [createFromForm, setCreateFromForm] = useState(true);
  const classes = useStyles();
  const history = useHistory();

  const createRepresentative = async (data) => {
    // console.log("final data", data);
    try {
      setLoading(true);

      const { status, response } =
        await laboratoryServices.addLabRepresentative({
          labRepresentativeInfo: {
            ...data,
            laboratoryId: authState.user.laboratory._id,
          },
          token: authState.token,
        });
      setToast(true);
      setToastMessage(
        status === 200
          ? "Representante agregado exitosamente"
          : response.message
      );
      if (status === 200) {
        setTimeout(() => {
          history.replace("/zones/representative");
        }, 700);
      }
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  };

  const onHandleUpload = async (formData) => {
    try {
      setLoading(true);
      formData.append("laboratoryId", authState.user.laboratory._id);

      const { status, response } = await laboratoryServices.addManyByFile({
        labRepresentativeInfo: formData,
        token: authState.token,
      });
      setToast(true);
      setToastMessage(
        status === 200
          ? "Representantes agregados exitosamente"
          : response.message
      );
      if (status === 200) {
        setTimeout(() => {
          history.replace("/zones/representative");
        }, 700);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };
  return (
    <>
      <Drawer open={isOpen} setOpen={(value) => setIsOpen(value)} />
      <Grid container className={classes.root}>
        {loading && <Loader loading={true} />}
        <Toast
          open={toast}
          message={toastMessage}
          close={() => setToast(false)}
        />
        <Grid item xs={12} className={classes.content}>
          <Container maxWidth={false}>
            <SimpleToolbar
              hideExport={authState.user.laboratory}
              isOpen={isOpen}
              setIsOpen={(value) => setIsOpen(value)}
              noSearchBar
            />
          </Container>

          <Container
            maxWidth={"md"}
            component={"main"}
            className={classes.container_main}
          >
            <Box display="flex" justifyContent={"end"} alignItems={"center"}>
              <Box>
                <Typography
                  variant="body2"
                  color="textSecondary"
                  component={"label"}
                  htmlFor="switch-create-from"
                >
                  {createFromForm
                    ? "Agregar desde formulario"
                    : "Agregar desde archivo"}
                </Typography>
                <Switch
                  id="switch-create-from"
                  checked={createFromForm}
                  onChange={() => setCreateFromForm((prev) => !prev)}
                />
              </Box>
            </Box>
            <Paper className={classes.custom_paper}>
              {createFromForm ? (
                <FormRepresentative onHandleSubmit={createRepresentative} />
              ) : (
                <Box component="section" padding={2}>
                  {/* <Typography component={"h2"} variant="h6">
                    Agregar representante desde archivo
                  </Typography> */}
                  <Typography variant="body2" style={{ marginBottom: 20 }}>
                    Sólo archivos con extensión ".xlsx", ".xls", ".csv"
                  </Typography>
                  <Button
                    component="a"
                    href={"/represunioWithZones.xlsx"}
                    target="_blank"
                    rel="noopener noreferrer"
                    download={true}
                    variant={"outlined"}
                    color={"primary"}
                    style={{ textTransform: "none", marginBottom:16 }}
                    startIcon={<CloudDownloadRounded/>}
                  >
                    {"Excel de ejemplo"}
                  </Button>
                  <FileUploader
                    allowedExtensions={[".xlsx", ".xls", ".csv"]}
                    onHandleUpload={onHandleUpload}
                    uploadStatus={loading}
                    title={'Agregar representantes'}
                  />
                </Box>
              )}
            </Paper>
          </Container>
        </Grid>
      </Grid>
    </>
  );
}
const useStyles = makeStyles((theme) => ({
  root: {
    paddingTop: 16,
    paddingBottom: 16,
    flex: 1,
    minHeight: "100vh",
  },
  content: {
    display: "flex",
    flexDirection: "column",
  },
  container_main: {
    display: "flex",
    flexDirection: "column",
    marginTop: theme.spacing(2),
    height: "100%",
  },
  custom_paper: {
    padding: theme.spacing(3),
    [theme.breakpoints.only("xs")]: {
      padding: theme.spacing(1),
    },
  },
}));
